import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { RoleAuthService } from "../services";
import { Observable } from "rxjs";
import {map, take} from 'rxjs/operators';
import { OidcSecurityService } from "angular-auth-oidc-client";

// This RouteGuard can be used if a user only needs to be authenticated.
@Injectable({
  providedIn: "root"
})
export class AuthenticationGuard implements CanActivate {
  private logoutUrl: string = "/logout";

  constructor(private router: Router, private authService: RoleAuthService, private oidcSecurityService: OidcSecurityService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      take(1),
      map(({ isAuthenticated }) => {
        if(isAuthenticated) {
          return true;
        } else {
          this.router.navigate([this.logoutUrl]);
          return false;
        }
      })
    );
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated().pipe(map(authorized => {
      return authorized;
    }));
  }
}
